import React from 'react';
import StyledPageHeader from './Styles';

const PageHeader = (props) => {
  const { children, ...otherProps } = props;
  return <StyledPageHeader {...otherProps}>{children}</StyledPageHeader>;
};

export default PageHeader;
